import { isFieldFilterValid } from 'module/types/filter-field/grouped-filter/utils';
import { Button } from 'module/ui/components/atoms/button/button';
import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import { faPen, faTrash } from '@fortawesome/pro-solid-svg-icons';
import { ICellRendererParams } from 'ag-grid-community';
import { FC } from 'react';
import styled from 'styled-components';
import { SectionData } from '../types';

const ActionsCellWrapper = styled.div`
  display: flex;
  gap: 8px;
  opacity: 0;
  transition: opacity 0.2s;
  .ag-row-hover & {
    opacity: 1;
  }
`;

interface ActionCellProps extends ICellRendererParams<SectionData> {
  onEditFilter: (section: SectionData) => void;
  onDeleteFilter: (section: SectionData) => void;
}

const ActionCell: FC<ActionCellProps> = ({
  onEditFilter,
  onDeleteFilter,
  data,
}) => {
  if (!data) {
    return null;
  }
  if (
    data.filter == null ||
    data.filter.groupCriteria.filter(({ criteria }) =>
      isFieldFilterValid(criteria),
    ).length === 0
  ) {
    return null;
  }

  return (
    <ActionsCellWrapper>
      <Button
        type="tertiary"
        size="small"
        icon={<FontAwesomeIcon icon={faPen} size={12} />}
        onClick={() => onEditFilter(data)}
      />
      <Button
        type="tertiary"
        size="small"
        icon={<FontAwesomeIcon icon={faTrash} size={12} />}
        onClick={() => onDeleteFilter(data)}
      />
    </ActionsCellWrapper>
  );
};

export { ActionCell };
